import React from "react";

const InboxSvg = () => {
	return (
		<svg
			width="77"
			height="77"
			viewBox="0 0 77 77"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Inbox picture</title>
			<path
				d="M8.27502 76.0375C6.16252 76.0375 4.41565 75.3469 3.0344 73.9657C1.65315 72.5844 0.962524 70.8375 0.962524 68.725V8.27502C0.962524 6.16252 1.65315 4.41565 3.0344 3.0344C4.41565 1.65315 6.16252 0.962524 8.27502 0.962524H68.725C70.8375 0.962524 72.5844 1.65315 73.9657 3.0344C75.3469 4.41565 76.0375 6.16252 76.0375 8.27502V68.725C76.0375 70.8375 75.3469 72.5844 73.9657 73.9657C72.5844 75.3469 70.8375 76.0375 68.725 76.0375H8.27502ZM8.27502 72.625H68.725C69.8625 72.625 70.7969 72.2594 71.5282 71.5282C72.2594 70.7969 72.625 69.8625 72.625 68.725V55.5625H54.3438C52.7188 58.65 50.5047 61.0469 47.7016 62.7532C44.8985 64.4594 41.8313 65.3125 38.5 65.3125C35.1688 65.3125 32.1016 64.4594 29.2985 62.7532C26.4953 61.0469 24.2813 58.65 22.6563 55.5625H4.37502V68.725C4.37502 69.8625 4.74065 70.7969 5.4719 71.5282C6.20315 72.2594 7.13752 72.625 8.27502 72.625ZM38.5 61.9C41.1 61.9 43.5375 61.25 45.8125 59.95C48.0875 58.65 49.7938 56.8219 50.9313 54.4657C51.3375 53.6532 51.9266 53.0641 52.6985 52.6985C53.4703 52.3328 54.3032 52.15 55.1969 52.15H72.625V8.27502C72.625 7.13752 72.2594 6.20315 71.5282 5.4719C70.7969 4.74065 69.8625 4.37502 68.725 4.37502H8.27502C7.13752 4.37502 6.20315 4.74065 5.4719 5.4719C4.74065 6.20315 4.37502 7.13752 4.37502 8.27502V52.15H21.8032C22.6969 52.15 23.5297 52.3328 24.3016 52.6985C25.0735 53.0641 25.6625 53.6532 26.0688 54.4657C27.2063 56.8219 28.9125 58.65 31.1875 59.95C33.4625 61.25 35.9 61.9 38.5 61.9ZM8.27502 72.625H4.37502H72.625H8.27502Z"
				fill="#5663F2"
			/>
		</svg>
	);
};

export default InboxSvg;
